class Project {
    id = null;
    name = '';
    user_id = null;
    date_created = null;
    deadline = null;
    uploaded_file = {
        name: '',
        link: '',
        original_name: '',
        upload_id: null,
    };
    active = true;
    amount = 0;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default Project;
